export default __webpack_public_path__ + "static/news5-b9824b02287fc3d7344fc8dbf9506b2a.jpg";